import { render, staticRenderFns } from "./departmentTree.vue?vue&type=template&id=527c5454&scoped=true&"
import script from "./departmentTree.vue?vue&type=script&lang=js&"
export * from "./departmentTree.vue?vue&type=script&lang=js&"
import style0 from "./departmentTree.vue?vue&type=style&index=0&id=527c5454&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527c5454",
  null
  
)

export default component.exports